import * as React from 'react'
import styled from 'styled-components'
import MoreHeaderParticles from '../../../../assets/img/more-header-particles.svg'
import TextInput from '../../../../components/ui/TextInput/TextInput'
import SearchIcon from '../../../../assets/img/search-icon.svg'
import Icon from '../../../../components/ui/Icon/Icon'
import {
  TRANSPORTATION_ROUTES,
  TRANSPORTATION,
} from '../../../../services/data/profilePages.json'
import {
  getLocations,
} from '../../../../services/api/requests/Explore'

const MainPage = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  font-size: 14px;
`

const Header = styled.div`
  position: relative;
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  min-height: 87px;
  font-size: 0.7rem;
  background: var(--color-primary);

  &::before {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${MoreHeaderParticles}');
    background-repeat: no-repeat;
    background-position: right top;
  }
`

const ReturnIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;
  border-radius: 2rem;
  cursor: pointer;
  font-size: 0.92rem;
  margin-left: 20px !important;
  margin-right: 20px !important;
  color: var(--color-fg-light);
  background: rgba(255, 255, 255, 0.5);
  z-index: 1;

  & > svg {
    position: relative;
    color: #ffffff;
  }
`

const Title = styled.h1`
  flex: 1;
  padding: 20px 0;
  margin: 0;
  margin-right: 60px;
  color: #ffffff;
  font-size: 1.125rem;
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  text-align: center;
`

const Content = styled.div`
  /*flex: 1 1 auto;
  padding: 0;
  overflow: auto;
  width: 100%;*/
`
const NavItem = styled.li`
  cursor: pointer;
  list-style: none;
  padding: 1rem;
  border-top: 1px solid var(--color-fg-lighter);
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: pointer;

  svg {
    color: var(--color-primary);
  }

  &:first-child {
    border-top: 0px;
  }

  &:hover {
    color: var(--color-primary);
  }
`

const ItemName = styled.span`
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  padding-left: 5px;
  font-size: 0.875rem;
`

const SearchWrapper = styled.div`
  padding: 1rem;
  /*display: flex;
  flex-direction: row;*/
  width: 100%;
  height: 100px;
`

const BlockSearchInput = styled(TextInput)`
  width: 100%;
  background-image: url(${SearchIcon});
  background-position: center right 10px;
  background-repeat: no-repeat;
  padding-right: 30px;
`

class FilterLocation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // TODO: define initial state
      locations: null,
      locationsFilter: null,
    }

    getLocations()
      .then(response => {
        this.setState({
          locations: response.data,
          locationsFilter: response.data,
        })
      })
      .catch(error => {
        const { errors: errorsObj } = this.state

        // errorsObj.mallRoutesError = error.message
        this.setState({ errors: errorsObj })
      })
  }

  searchLocation = e => {
    const { locations } = this.state
    const { value: query = '' } = (e || {}).target || {}

    if (query === '') {
      this.setState({
        locationsFilter: locations,
      })
    } else {
      const filter = locations.filter(location => {
        const locationName = location.name.toLowerCase()
        let regex = new RegExp(`${query}`, 'gi')
        let matching = locationName.match(regex)
        return matching
      })

      this.setState({
        locationsFilter: filter,
      })
    }
  }

  render() {
    const { setProfileModalPage, setTransportationMall } = this.props
    // TODO: define template
    return (
      <>
        <MainPage show="true" /*show={!selectedFAQ}*/>
          <Header>
            <ReturnIcon onClick={() => setProfileModalPage(TRANSPORTATION)}>
              <Icon name="slide-left" />
            </ReturnIcon>
            <Title>Filter by location</Title>
          </Header>
          <Content>
            <SearchWrapper>
              <BlockSearchInput
                placeholder="Filter by Location"
                onChange={this.searchLocation}
              />
            </SearchWrapper>
            <>
              {this.state.locationsFilter &&
                this.state.locationsFilter.length > 0 &&
                this.state.locationsFilter.map(location => {
                  return (
                    <NavItem
                      onClick={() => {
                        setTransportationMall({
                          ...location,
                          type: 'location',
                          locationName: location.name,
                        })
                        setProfileModalPage(TRANSPORTATION_ROUTES)
                      }}
                    >
                      <ItemName>{location.name}</ItemName>

                      <Icon name="slide-right" />
                    </NavItem>
                  )
                })}
            </>
          </Content>
        </MainPage>
      </>
    )
  }
}

FilterLocation.defaultProps = {
  // TODO: specify default props
}

FilterLocation.propTypes = {
  // TODO: specify prop types
}

export default FilterLocation
